/* global Office, Word */
import "./taskpane.css";
Office.onReady(() => {
  const sideloadMsg = document.getElementById("sideload-msg");
  const appBody = document.getElementById("app-body");
  const applyButton = document.getElementById("apply-letterhead");

  if (sideloadMsg) {
    sideloadMsg.style.display = "none";
  }

  if (appBody) {
    appBody.style.display = "flex";
    appBody.style.flexDirection = "column";
  }

  if (applyButton) {
    applyButton.onclick = applyLetterhead;
  }
});

function hasRequiredWordApis(): boolean {
  return (
    Office.context.requirements.isSetSupported("WordApi", "1.3") &&
    Office.context.requirements.isSetSupported("WordApi", "1.2")
  );
}

async function getImageBase64(url: string): Promise<string> {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Impossibile caricare l'immagine: ${url} (${response.status})`);
  }

  const blob = await response.blob();

  return await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const result = reader.result as string;
      const base64 = result.split(",")[1];
      resolve(base64);
    };

    reader.onerror = () => reject(new Error(`Errore nella conversione Base64 di ${url}`));
    reader.readAsDataURL(blob);
  });
}

function formatTodayItalian(): string {
  return new Intl.DateTimeFormat("it-IT").format(new Date());
}

async function applyLetterhead() {
  const status = document.getElementById("status");
  const addIntroTable =
    (document.getElementById("insert-intro-table") as HTMLInputElement)?.checked ?? false;

  try {
    if (!hasRequiredWordApis()) {
      throw new Error("Il client Word non supporta le API richieste (WordApi 1.2 / 1.3).");
    }

    if (status) {
      status.textContent = "Applicazione layout in corso...";
    }

    // Carica immagini dagli assets
    const logoBase64 = await getImageBase64("/assets/logo.png");
    const footerBase64 = await getImageBase64("/assets/footer.png");
    const today = formatTodayItalian();

    await Word.run(async (context) => {
      const section = context.document.sections.getFirst();

      const header = section.getHeader(Word.HeaderFooterType.primary);
      const footer = section.getFooter(Word.HeaderFooterType.primary);

      header.clear();
      footer.clear();

      // =========================================================
      // HEADER - solo logo, senza tabelle, a sinistra
      // =========================================================
      const headerLogoParagraph = header.insertParagraph("", Word.InsertLocation.start);
      headerLogoParagraph.alignment = Word.Alignment.left;
      headerLogoParagraph.leftIndent = -35;

      const logoImage = headerLogoParagraph.insertInlinePictureFromBase64(
        logoBase64,
        Word.InsertLocation.start
      );

      logoImage.lockAspectRatio = true;
      logoImage.height = 38;

      // =========================================================
      // FOOTER - immagine con spostamento più a sinistra
      // =========================================================
      if (Office.context.requirements.isSetSupported("WordApiDesktop", "1.3")) {
        section.pageSetup.footerDistance = 5;
      }

      const footerParagraph = footer.insertParagraph("", Word.InsertLocation.start);
      footerParagraph.alignment = Word.Alignment.left;
      footerParagraph.leftIndent = -30;

      const footerImage = footerParagraph.insertInlinePictureFromBase64(
        footerBase64,
        Word.InsertLocation.start
      );

      footerImage.lockAspectRatio = true;
      footerImage.height = 25.5;

      // =========================================================
      // TABELLA INIZIALE NEL BODY (opzionale)
      // =========================================================
      if (addIntroTable) {
        const body = context.document.body;

        body.insertParagraph("", Word.InsertLocation.start);

        const introData = [
          ["Data", today],
          ["Vs. Rif.:", ""],
          ["Offerta n°", `${new Date().getFullYear()}`]
        ];

        const introTable = body.insertTable(
          introData.length,
          2,
          Word.InsertLocation.start,
          introData
        );

        introTable.alignment = Word.Alignment.left;

        // Font generale tabella
        introTable.font.name = "Calibri";
        introTable.font.size = 10;

        // Nessun bordo visibile
        introTable.getBorder(Word.BorderLocation.all).type = "None";
        introTable.getBorder(Word.BorderLocation.outside).type = "None";
        introTable.getBorder(Word.BorderLocation.inside).type = "None";
        introTable.getBorder(Word.BorderLocation.insideHorizontal).type = "None";
        introTable.getBorder(Word.BorderLocation.insideVertical).type = "None";
        introTable.getBorder(Word.BorderLocation.left).type = "None";
        introTable.getBorder(Word.BorderLocation.right).type = "None";
        introTable.getBorder(Word.BorderLocation.top).type = "None";
        introTable.getBorder(Word.BorderLocation.bottom).type = "None";

        // Prima colonna in grassetto
        introTable.getCell(0, 0).body.font.bold = true;
        introTable.getCell(1, 0).body.font.bold = true;
        introTable.getCell(2, 0).body.font.bold = true;

        // Font uniformi per tutte le celle
        introTable.getCell(0, 0).body.font.name = "Calibri";
        introTable.getCell(0, 0).body.font.size = 10;
        introTable.getCell(0, 1).body.font.name = "Eurostile";
        introTable.getCell(0, 1).body.font.size = 10;

        introTable.getCell(1, 0).body.font.name = "Calibri";
        introTable.getCell(1, 0).body.font.size = 10;
        introTable.getCell(1, 1).body.font.name = "Eurostile";
        introTable.getCell(1, 1).body.font.size = 10;

        introTable.getCell(2, 0).body.font.name = "Calibri";
        introTable.getCell(2, 0).body.font.size = 10;
        introTable.getCell(2, 1).body.font.name = "Eurostile";
        introTable.getCell(2, 1).body.font.size = 10;

        // Larghezza colonne: solo se Desktop supporta WordApiDesktop 1.3
        if (Office.context.requirements.isSetSupported("WordApiDesktop", "1.3")) {
          section.load("pageSetup/pageWidth,pageSetup/leftMargin,pageSetup/rightMargin");
          introTable.columns.load("items");
          await context.sync();

          const pageSetup = section.pageSetup;

          // area utile della pagina
          const printableWidth =
            pageSetup.pageWidth - pageSetup.leftMargin - pageSetup.rightMargin;

          // tabella al 30% della larghezza utile
          const tableWidth = printableWidth * 0.30;

          // esempio: colonna 1 = 40%, colonna 2 = 60%
          const col1Width = tableWidth * 0.40;
          const col2Width = tableWidth * 0.60;

          introTable.columns.items[0].setWidth(col1Width, Word.RulerStyle.none);
          introTable.columns.items[1].setWidth(col2Width, Word.RulerStyle.none);
        }

        body.insertParagraph("", Word.InsertLocation.start);
      }

      await context.sync();
    });

    if (status) {
      status.textContent = "Carta intestata applicata correttamente.";
    }
  } catch (error) {
    console.error(error);

    if (status) {
      const message =
        error instanceof Error
          ? error.message
          : "Errore sconosciuto durante l'applicazione del layout.";
      status.textContent = `Errore: ${message}`;
    }
  }
}